"use client";

import { FC } from "react";
import Skeleton from "react-loading-skeleton";

interface BFLSkeletonProps {
  width?: number | string;
  height?: number;
  count?: number;
  classes?: string;
  borderRadius?: number;
}

const BFLSkeleton: FC<BFLSkeletonProps> = ({
  width = "100%",
  height = 20,
  count = 1,
  classes = "",
  borderRadius,
}) => {
  return (
    <Skeleton
      width={width}
      height={height}
      count={count}
      className={classes}
      {...(borderRadius !== null && { borderRadius })}
    />
  );
};

export default BFLSkeleton;
